import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Snackbar from "@mui/material/Snackbar";

import Grid from "@mui/material/Grid";

import bimLogo from '../images/bim_logo_100.png';
import Button from "@mui/material/Button";
import {SnackbarContent} from "@mui/material";
import {useState} from "react";

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" mt={1}>
    </Typography>
  );
}

export default function Footer() {

    const [snackbar, setSnackbar] = useState(true);

  return (
    <Grid
        container
      sx={{
          width: '100%',
          // marginTop: 'auto'
          // marginBottom: 0
      }}
    >
        <Grid
            sx={{
                display: 'flex',
                backgroundColor: "#f6f6f6",
                justifyContent: 'start',
            }}
            spacing={4}
            p={4}
            container>
            <Container>
            <Grid container sx={{fontSize: '12px'}} spacing={2}>
                <Grid item xs={12} sm={4}>
                    <Stack sx={{alignItems: {xs: 'center', sm: 'start'}}} direction={{xs: 'row', sm: 'column'}} spacing={2}>
                        <Box
                            component={'img'}
                            src={bimLogo}
                        />
                        <Box>
                            <Typography align={'left'} sx={{fontSize: '14px'}}>Телефон 24/7: +7 (993) 273-10-83</Typography>
                            <Typography align={'left'} sx={{fontSize: '14px'}}>Email: hello@bimclinics.ru</Typography>
                        </Box>
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Stack spacing={1}>
                        <Typography align={'left'} sx={{fontSize: '12px'}}>
                            Юридические документы
                        </Typography>
                        <Link href={'/policy'}
                            target="_blank"
                              rel="nofollow noopener"
                        >
                            <Typography align={'left'} sx={{fontSize: '10px'}}>Политика обработки персональных данных</Typography>
                        </Link>
                        <Link href={'/consent'}
                              target="_blank"
                              rel="nofollow noopener"
                        >
                            <Typography align={'left'} sx={{fontSize: '10px'}}>Согласие на обработку персональных данных</Typography>
                        </Link>
                        <Link href={'/offer'}
                              target="_blank"
                              rel="nofollow noopener"
                        >
                            <Typography align={'left'} sx={{fontSize: '10px'}}>Публичная оферта на оказание услуг массажа</Typography>
                        </Link>
                        <Link href={'/offer-specialist'}
                              target="_blank"
                              rel="nofollow noopener"
                        >
                            <Typography align={'left'} sx={{fontSize: '10px'}}>Публичная оферта на выполнение заказов для специалистов по массажу</Typography>
                        </Link>
                        <Link href={'/pep'}
                              target="_blank"
                              rel="nofollow noopener"
                        >
                            <Typography align={'left'} sx={{fontSize: '10px'}}>Соглашение об использовании простой электронной подписи</Typography>
                        </Link>
                        <Link href={'/pricing'}
                              target="_blank"
                              rel="nofollow noopener"
                        >
                            <Typography align={'left'} sx={{fontSize: '10px'}}>Стоимость услуг</Typography>
                        </Link>
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Stack spacing={1}>
                        <Typography align={'left'} sx={{fontSize: '12px'}}>
                            Клиентам
                        </Typography>
                        <Link href={'https://app.bimclinics.ru'}>
                            <Typography align={'left'} sx={{fontSize: '10px'}}>Приложение с услугами</Typography>
                        </Link>
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Stack spacing={1}>
                        <Typography align={'left'} sx={{fontSize: '12px'}}>
                            Партнерам
                        </Typography>
                        <Link href={'https://med.bimclinics.ru'}>
                            <Typography align={'left'} sx={{fontSize: '10px'}}>Приложение для партнеров</Typography>
                        </Link>
                        <Link href={'/partners'}>
                            <Typography align={'left'} sx={{fontSize: '10px'}}>Условия работы</Typography>
                        </Link>
                    </Stack>
                </Grid>
        </Grid>
            </Container>
                </Grid>
        <Grid
            sx={{
                backgroundColor: '#f6f6f6',
                height: '50px',
                display: 'flex',
                justifyContent: 'center',
            }}
            container>
            <Copyright />
        </Grid>
        <Snackbar
            open={snackbar}
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            sx={{
                backgroundColor: "#f6f6f6",
                color: '#000000'
            }}
        >
            <SnackbarContent style={{
                backgroundColor:'#f9f9f9',
                color: '#000000'
            }}
             message={<span>Этот сайт использует файлы cookie. Продолжая использовать этот сайт, вы соглашаетесь на их использование</span>}
             action={<Button onClick={() => {setSnackbar(false)}}>ОК</Button>}
            />
        </Snackbar>
    </Grid>
  );
}
